import { inject, Injectable } from '@angular/core';
import { CurrentUserService } from 'app/core/user/current-user.service';
import { User } from 'app/core/user/user.types';
import { Observable, ReplaySubject, of } from 'rxjs';

@Injectable({providedIn: 'root'})
export class UserService
{
    private readonly _currentUser = inject(CurrentUserService);
    private _user: ReplaySubject<User> = new ReplaySubject<User>(1);

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Setter & getter for user
     *
     * @param value
     */
    set user(value: User)
    {
        // Store the value
        this._user.next(value);
    }

    get user$(): Observable<User>
    {
        return this._user.asObservable();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get the current signed-in user data
     *
     * The token carries the user's claims, so this resolves from CurrentUserService rather
     * than from an endpoint.
     */
    get(): Observable<User>
    {
        const user: User = {
            email : this._currentUser.email,
            name  : this._currentUser.name,
            id    : this._currentUser.id,
            avatar: '',
            status: '',
        };

        return of(user);
    }
}
